import React, {Fragment} from "react";
import PropTypes from "prop-types";
import SpinnerDiv from "../Components/SpinnerDiv";
import PassportTable, {xlateBootstrapTableColumns} from "root/Tables/PassportTable";

import './AgreementsTable.scss' ;

import {
    defaultTableHeaderStyles,
    defaultPaginationOptions,
    customHeaderStyle,
    defaultTopLeftCellStyle,
    defaultTopRightCellStyle,
    TableActionIconGeneric, TableActionIconGenericBootstrap,
} from "./BaseTableComponents";

import './Table.scss'
import {ModalCommunicationPlanModes} from "root/Modals/CommunicationPlan/ModalCommunicationPlan";
import {CommsPlanStatusValues} from "root/DataFunctions/Constants";
import {runContactPlanLeeds} from "root/PDFContactPlan/ContactPlanLeedsBirthParent";
import {runContactPlanAdopterLeeds} from "root/PDFContactPlan/ContactPlanLeedsAdopter";

import {FamilyTypes} from "root/DataFunctions/Constants";
import {Link} from "react-router-dom";

const AgreementsTable = ({data,isLoading,child_uid,onClick}) =>
{
    const runContactPlan = ( cp_template_id, family_type_id, communications_plan_id ) =>
    {
        switch ( family_type_id )
        {
            // This needs some thinking about to determine how we will do templates in future for different authorities
            case FamilyTypes.BIRTH:
                runContactPlanLeeds( child_uid, communications_plan_id ) ;
                break ;
            case FamilyTypes.FOREVER:
                runContactPlanAdopterLeeds( child_uid, communications_plan_id ) ;
                break ;
            default:
                runContactPlanLeeds( child_uid, communications_plan_id ) ;
                break;
        }
    }
    const statusRenderer = (cell, row, rowIndex, formatExtraData) => {
        let color = "#076dc0";

        const statusColours = {
            1: '#076dc0',
            2: '#E1720B',
            3: '#216C06'
        }

        if (statusColours[+(row.plan_status_id)] !== undefined)
        {
            color = statusColours[+(row.plan_status_id)];
        }

        return <div style={{borderRadius: "5px", color: color}}>{cell}</div>;
    };

    const nameList = ( row, names ) =>
    {
        return names.map((item, index) =>
        {
            const u1URL = '/home/users/' + item.enc_from_user_id + '/connections?name=' + item.connection_firstname + " " + item.connection_surname ;

            return (
                <Fragment>
                    <div className='agreement-member-row'>
                        <div className='r1'><Link to={u1URL}>{item.connection_firstname + " " + item.connection_surname}</Link></div>
                        <div className='r2'>{item.type_name + ' ' + item.name}</div>
                        <div className='r3'><TableActionIconGenericBootstrap text='View Agreement PDF' onClick={() => runContactPlan( +(row.cp_template_id), +(item.family_type_id), row.communications_plan_id)} icon='bi-filetype-pdf' color="var(--s360-icon-blue)" /> </div>
                    </div>
                </Fragment>
            )
        })
    }

    const childConnectionRenderer = (cell, row, rowIndex, formatExtraData) => {

        const names = nameList(row, row.connections) ;

        return (
            <div className='agreement-members' style={{borderRadius: "5px", textAlign: "left", width: "30vw"}}>
                { names }
            </div>
        );
    };

    const childConnectionTypeRenderer = (cell, row, rowIndex, formatExtraData) => {
        return (
            <div style={{borderRadius: "5px", textAlign: "left", width: "30vw"}}>
                {row.type_name + " " + row.name}
            </div>
        );
    };

    const linkFormatter = (cell, row, rowIndex, formatExtraData) => {

        if (row.typeName === 'Birth Parent')
        {
            return (
                <Fragment>
                    <TableActionIconGeneric text='View Document'
                                            onClick={() => runContactPlan(row.from_user_id, row.communications_plan_id)}
                                            icon='icon icon-files icon-fw icon-xl'/>
                </Fragment>
            )
        }
        else
        {
            const shouldShowFinalise = +(row.plan_status_id) === CommsPlanStatusValues.DRAFT ;
            const shouldShowReopen = +(row.plan_status_id) === CommsPlanStatusValues.APPROVED ;

            return (
                <Fragment>
                    { shouldShowFinalise === true && <TableActionIconGenericBootstrap text='Finalise Agreement' onClick={() => onClick({ mode: ModalCommunicationPlanModes.FINALISE, child_uid: child_uid, communications_plan_id: row.communications_plan_id })} icon='bi-hand-thumbs-up-fill' color="var(--s360-icon-green)" /> }
                    { shouldShowReopen === true && <TableActionIconGenericBootstrap text='Re-Open Agreement' onClick={() => onClick({ mode: ModalCommunicationPlanModes.REOPEN, child_uid: child_uid, communications_plan_id: row.communications_plan_id })} icon='bi-folder-symlink' color="var(--s360-icon-green)" /> }
                    { shouldShowFinalise === true && <TableActionIconGenericBootstrap text='Edit Contact Agreement Details' to={'commsplans/' + row.communications_plan_id} icon='bi-pencil-fill' color="var(--s360-icon-blue)" /> }
                    { shouldShowFinalise === true && <TableActionIconGeneric text='Delete Agreement' onClick={() => onClick({ mode: ModalCommunicationPlanModes.DELETE, child_uid: child_uid, communications_plan_id: row.communications_plan_id })} icon='icon-trash' color="var(--s360-icon-red)" /> }
                </Fragment>
            )
        }
    }

    const headerStyle = customHeaderStyle.bind(null, {
        default: defaultTableHeaderStyles,
        firstname: {borderRadius: defaultTopLeftCellStyle},
        cp_plan_title: {width: "14vw"},
        date_created: {width: "6vw"},
        status_text: {width: "5vw"},
        plan_version: {width: "1vw"},
        view_plan: {borderRadius: defaultTopRightCellStyle, width: "6vw"}
    });

    const getColumns = () => {
        const columns = [
            {
                dataField: "firstname",
                text: "Name (s)",
                formatter: childConnectionRenderer,
                headerStyle: headerStyle
            },
            {
                dataField: "cp_plan_title",
                text: "Plan Title",
                headerStyle: headerStyle
            },
            {
                dataField: "date_created",
                text: "Created",
                sort: true,
                headerStyle: headerStyle
            },
            {
                dataField: "status_text",
                text: "Status",
                formatter: statusRenderer,
                headerStyle: headerStyle
            },
            {
                dataField: "plan_version",
                text: "Version",
                headerStyle: headerStyle
            },
            {
                dataField: "view_plan",
                text: "",
                formatter: linkFormatter,
                align: 'right',
                headerStyle: headerStyle
            },
        ];

        return columns;
    };

    const translations = xlateBootstrapTableColumns(getColumns());
    const columns = React.useMemo(() => translations, []);

    const thisTableContent = () =>
    {
        return <PassportTable data={data} columns={columns} pagination={defaultPaginationOptions}/>
    }

    return isLoading === true ? <SpinnerDiv/> : thisTableContent();
};

export default AgreementsTable;

AgreementsTable.propTypes = {
    data: PropTypes.array,
    isLoading: PropTypes.bool,
    child_uid: PropTypes.string,
    onClick: PropTypes.func
};